<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil bwlist" style="background:#fff;">
            <a-card>
                <div class="search">
                    <label for="">公告标题：</label>
                    <a-input style="width:250px;margin-right:16px" v-model="keywords"></a-input>
                    <a-button type="primary" @click="search">搜索</a-button>
                </div>
                <a-table
                :columns="columns"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
                :data-source="data"
                >
                    <span slot=type slot-scope="type">
                        <span v-if="type==1">系统公告</span>
                        <span v-else>活动公告</span>
                    </span>
                    <span slot="action" slot-scope="text, record">
                        <router-link  :to="{name:'detail', params: {id:record.id}}">
                            <a href="javascript:;"><a-icon type="file-search"/>查看</a>
                        </router-link>
                    </span>
                </a-table>
            </a-card>
        </div>
    </div>
</template>

<script>

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '公告标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '公告类型',
    dataIndex: 'type',
    key: 'type',
    filters: [
      { text: '系统公告', value: '1' },
      { text: '活动公告', value: '2' },
    ],
    filterMultiple: false,
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '发布时间',
    dataIndex: 'update_time',
    key: 'update_time',
    sorter: (a, b) => a.update_time - b.update_time,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  }
];


export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '消息公告'},
            ],
            data:"",
            columns,
            pagination: {},
            loading: false,
            keywords:""
        }
    },
    mounted(){
        this.fetch()
        // this.$axios.get('/api/getmessagelist',{
        //     headers: {
        //         "appid": this.appSet.appid,
        //         "appkey": this.appSet.appkey,
        //         "token":localStorage.getItem('token'),
        //     }
        // }).then((res)=>{
        //     if(res.data.code==200){
        //         this.data=res.data.data.lists
        //     }
        // })
    },
    methods:{
        search(){
            this.fetch()
        },
        // 消息详情
        handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },

        fetch(params = {}) {

            params=JSON.parse(JSON.stringify(params).replace(/sortOrder/g, 'order'));
        
            if(params.order=='descend'){
                params.order=2
            }else{
                params.order=1
            }
            console.log('params:', params);
            if(params.type){
                params.type=params.type[0]
            }

            this.loading = true;
            this.$axios.get('/api/getmessagelist',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    keywords:this.keywords,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                    // this.data=res.data.data.lists
                    // this.loading = false;
                    // this.pagination = pagination;
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })

        },

    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/message.vue